import type { AwDropdownMenuItem } from "@asap/design";
import type { TaskAction } from "@asap/shared/schemas/task/action-type";
import type { Task } from "@asap/shared/schemas/task/crud";
import { createSharedComposable } from "@vueuse/core";
import { getTaskActionLabels, TASK_ACTION_CATALOG, TASK_ACTIONS } from "~/utils/task-action";

export const useTaskTrigger = createSharedComposable(() => {
  const { t } = useI18n();
  const isOpen = ref(false);
  const selectedAction = ref<TaskAction | null>(null);

  // Due to the modal being accessible from the NavBar, the task lists (tasks page, company tab) watch this
  const lastCreatedTask = ref<Task | null>(null);

  const open = (actionType: TaskAction | null) => {
    selectedAction.value = actionType;
    isOpen.value = true;
  };

  const notifyTaskCreated = (task: Task) => {
    lastCreatedTask.value = task;
  };

  const taskActionLabels = getTaskActionLabels(t);

  const menuItems = computed<AwDropdownMenuItem[]>(() => [
    {
      icon: "i-ph-plus",
      label: t("tasks.create.newTask"),
      onClick: () => open(null),
    },
    ...TASK_ACTIONS.map((action) => ({
      icon: TASK_ACTION_CATALOG[action].icon,
      label: taskActionLabels[action],
      onClick: () => open(action),
    })),
  ]);

  return {
    isOpen,
    selectedAction,
    open,
    menuItems,
    lastCreatedTask,
    notifyTaskCreated,
  };
});
